import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  booleanAttribute,
} from '@angular/core';
import { SeparatorComponent } from '../separator/separator.component';
import { ButtonComponent } from '../button/button.component';
import { ClickOutsideDirective } from 'src/app/directives/click-outside.directive';

@Component({
  selector: 'vti-modal',
  templateUrl: './modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, SeparatorComponent, ButtonComponent, ClickOutsideDirective],
})
export class ModalComponent {
  @Input({ required: true, transform: booleanAttribute }) public visible!: boolean;
  @Input() public headerText: string | undefined;
  @Input({ transform: booleanAttribute }) public closable: boolean | undefined;

  @ContentChild('content') public content!: TemplateRef<any>;
  @ContentChild('footer') public footer!: TemplateRef<any>;

  @Output() public onClose: EventEmitter<void> = new EventEmitter<void>();

  public closeModal(): void {
    if (this.closable) {
      this.onClose.emit();
    }
  }
}
